Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFetchPreviewPage = void 0;

var getters_1 = require("./getters");

var admin_core_1 = require("@wheelroom/admin-core");

var react_1 = require("react");

var defaultNeedsFetch = function defaultNeedsFetch(pageProps, previewPage) {
  if (!previewPage) {
    return true;
  }

  return pageProps.data.page.path !== previewPage.path;
};

exports.useFetchPreviewPage = function (setPreviewPage) {
  var needsFetch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultNeedsFetch;

  var _react_1$useContext = react_1.useContext(admin_core_1.AdminCoreContext),
      adminCoreState = _react_1$useContext.adminCoreState;

  var pagePreviewStore = getters_1.getPreviewPageStore(adminCoreState);
  react_1.useLayoutEffect(function () {
    var pageProps = adminCoreState.pageProps;

    if (!pagePreviewStore || !pageProps) {
      return;
    }

    var pagePreviewState = pagePreviewStore.state;

    if (!pagePreviewState.inPreviewMode) {
      return;
    }

    var previewPage = pagePreviewState.previewPage;

    if (!pagePreviewState.isFetching && needsFetch(pageProps, previewPage)) {
      pagePreviewStore.actions.fetchPage(adminCoreState);
    }

    setPreviewPage(previewPage);
  }, [adminCoreState]);
};